
import certificate from '../components/certificate/index.vue'
import dispoitStep from '../components/dispoit-step.vue'
import dispointHeader from '../components/dispoint-header.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import { common, commonApi, check } from '@/common/index'
import getPayInfoMX from '../mixins/getPayInfo.js'
import publicMX from '../../mixins/publicMX.js'
export default {
directives: {
TransferDom
},
mixins: [getPayInfoMX, publicMX],
components: {
XButton,
Group,
XInput,
Icon,
Confirm,
dispoitStep,
certificate,
dispointHeader
},
data() {
return {
bankLists: [],
deposit: { imgUrl: '', amount: '', payerName: '' }
}
},
methods: {
handSelectBank(item) {
this.paySelected = item
},
}
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/SaveMonery/BankTransfer/index.vue